import {ACTIONS} from '../../actions/companies.actions';
import {idMap} from '../../util/idMap';

const initialState = {
  fetchInProgress: false,
  featchError: '',
  companies: {}
}

export default (state = initialState,action) => {

  switch(action.type){

    case ACTIONS.LoadCompaniesInProgress: {
      return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
        companies: {}
      };
    }

    case ACTIONS.LoadCompaniesFailed: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: action.payload,
        companies: {}
      };
    }

    case ACTIONS.LoadCompaniesCompleted: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        companies: idMap(action.payload, '_id')
      }
    }

    default: 
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/companies/index.js